import { Injectable } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import { AngularFirestore } from '@angular/fire/firestore';
import { Camera, CameraOptions } from '@ionic-native/camera/ngx';
import { Storage } from '@ionic/storage';

@Injectable({
  providedIn: 'root'
})
export class PhotoService {

  public photos: Photo[] = [];
  public base64Str=null;
  constructor(private camera: Camera, private storage: AngularFirestore,
    private auth:AngularFireAuth) { }

  takePicture() {
    
  }
  async tomarFoto(){
    const options:CameraOptions={
      sourceType: this.camera.PictureSourceType.CAMERA,
      saveToPhotoAlbum: false, 
      correctOrientation: true,
      targetWidth: 1000,
      targetHeight: 1000, 
      destinationType: this.camera.DestinationType.DATA_URL,
      mediaType: this.camera.MediaType.PICTURE,
      encodingType: this.camera.EncodingType.JPEG,
      cameraDirection: this.camera.Direction.FRONT
    }


    this.camera.getPicture(options).then((imageData)=>{
    this.base64Str='data:image/jpeg;base64,'+imageData;


    this.base64Str='data:image/jpeg;base64,'+imageData;
    this.loadSaved()
   })


}
  loadSaved() {
    this.auth.auth.onAuthStateChanged(d=>{
        this.storage.collection('usuarios').doc(d.uid).update({
          'foto':this.base64Str
        }).then(()=>{
          window.location.reload()
        })
    })
  }
 
}

class Photo {
  data: any;
}
